import React from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';
import style from './style.module.scss';
import SportsTypeImage from 'components/sportsTypeImage';

const PromptItem = observer(({ item }) => {
  const {
    sportsType,
    leagueName,
    eventTime,
    home,
    away,
    isVisible,
    remove,
    location
  } = item;

  return (
    <li className={clsx(style.promptItem, isVisible ? style.in : style.out)}>
      <SportsTypeImage sportsType={sportsType} height={20} width={20} />
      <div className={style.league}>
        <span>{leagueName}</span>
      </div>
      <div className={style.time}>
        <span>{eventTime}</span>
      </div>
      <div className={style.score}>
        <div className={clsx(style.home, location === 'home' && style.active)}>
          <div className={style.team_name}>
            <span>{home.name}</span>
          </div>
          <span className={style.team_score}>{home.score}</span>
        </div>
        <span className={style.score_center}>:</span>
        <div className={clsx(style.away, location === 'away' && style.active)}>
          <span className={style.team_score}>{away.score}</span>
          <div className={style.team_name}>
            <span>{away.name}</span>
          </div>
        </div>
      </div>
      <div className={style.close}>
        <button onClick={remove} />
      </div>
    </li>
  );
});

export default PromptItem;
